import Intercom, { shutdown } from "@intercom/messenger-js-sdk";
import { INTERCOM_APP_ID } from "src/utils/constants";
import { useEffect } from "react";

export default function PublicIntercom() {
  useEffect(() => {
    Intercom({
      app_id: INTERCOM_APP_ID,
      action_color: "#ccc3ae",
    });
    // Shut down the anonymous session when the user leaves the public page
    // (e.g. after login) so the authenticated IntercomComponent can boot
    // fresh with the signed JWT.
    return () => {
      shutdown();
    };
  }, []);

  return <></>;
}
